import React from "react";
import {useBlogdata_bylang } from "../FetchAPI";
import BlogHomebox from "./BlogHomebox";


export default function Blog({ language }) {
    const [Blogs] = useBlogdata_bylang(language);
    return (
        <>


            {/* Blog section Start */}

            <section className="blog_section_new section_padding_bottom">

                <div className="container">
                    <div
                        className="blog_heading_wrap"
                        style={{ textAlign: "left" }}
                    >
                        <span className="blog_sub_title">
                            LATEST ARTICLES
                        </span>
                        <h2 className="blog_main_title">
                            Our Latest Blogs
                        </h2>
                    </div>

                    <div className="row blog_row_space">

                        {Blogs?.map((value, index) => (
                            <BlogHomebox
                                key={index}
                                slug={value.slug}
                                lang={value.lang}
                                image={value.sort_img}
                                image_title={value.image_title}
                                image_alt={value.image_alt}
                                date={value.date}
                                title={value.title}
                                tagline={value.tagline}
                            />
                        ))}

                    </div>

                </div>

            </section>

            {/* Blog section End */}
        </>
    );
}
